import React from 'react'

import Banner from 'components/Banner'
import DesktopBadge from 'components/Notifications/DesktopBadge'
import ToasterContainer from 'components/Utils/Toaster/Container'
import ConnectionChecker from 'components/Utils/ConnectionChecker'
import Search from 'screens/Search'

import Shortcuts from './Shortcuts'
import PrivacyModal from '../Privacy'

export const AppViewPortals = React.memo(() => (
  <React.Fragment>
    <Shortcuts />
    <DesktopBadge />
    <Banner />
    <PrivacyModal />
    <ToasterContainer />
    <ConnectionChecker />
    <Search />
  </React.Fragment>
))
